import React from "react";

const WhyAbout =(props) => {
    return(
        <>
        <div className="aboutus-style">
            <img src={props.img} alt="Why us"/>
            <h2>{props.heading}</h2>
            <p>{props.para}</p>
        </div>
        </>
    );
}

export default WhyAbout ;